export default () => {
  const loginTrigger = document.querySelector(
    '.c-footer__navigation [href="#footer-login-links"]',
  );
  const loginLinks = document.getElementById('footer-login-links');

  if (loginLinks !== null && loginTrigger !== null) {
    loginTrigger.addEventListener('click', event => {
      event.preventDefault();
      loginLinks.classList.toggle('active');

      if (loginLinks.classList.contains('active')) {
        window.scrollBy(0, 100);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/footer.js